

const countryData = [
    { code: 'GB', dialCode: '+44', name: 'United Kingdom', flag: 'https://flagcdn.com/w40/gb.png' },
    { code: 'US', dialCode: '+1', name: 'United States', flag: 'https://flagcdn.com/w40/us.png' },
    { code: 'IN', dialCode: '+91', name: 'India', flag: 'https://flagcdn.com/w40/in.png' },
    { code: 'AU', dialCode: '+61', name: 'Australia', flag: 'https://flagcdn.com/w40/au.png' },
    { code: 'DE', dialCode: '+49', name: 'Germany', flag: 'https://flagcdn.com/w40/de.png' },
    { code: 'FR', dialCode: '+33', name: 'France', flag: 'https://flagcdn.com/w40/fr.png' },
    { code: 'CA', dialCode: '+1', name: 'Canada', flag: 'https://flagcdn.com/w40/ca.png' },
    { code: 'JP', dialCode: '+81', name: 'Japan', flag: 'https://flagcdn.com/w40/jp.png' },
    { code: 'BR', dialCode: '+55', name: 'Brazil', flag: 'https://flagcdn.com/w40/br.png' },
    { code: 'CN', dialCode: '+86', name: 'China', flag: 'https://flagcdn.com/w40/cn.png' },
    { code: 'RU', dialCode: '+7', name: 'Russia', flag: 'https://flagcdn.com/w40/ru.png' },
    { code: 'MX', dialCode: '+52', name: 'Mexico', flag: 'https://flagcdn.com/w40/mx.png' },
    { code: 'ZA', dialCode: '+27', name: 'South Africa', flag: 'https://flagcdn.com/w40/za.png' },
    { code: 'SG', dialCode: '+65', name: 'Singapore', flag: 'https://flagcdn.com/w40/sg.png' },
    { code: 'AE', dialCode: '+971', name: 'United Arab Emirates', flag: 'https://flagcdn.com/w40/ae.png' },
    { code: 'KR', dialCode: '+82', name: 'South Korea', flag: 'https://flagcdn.com/w40/kr.png' },
    { code: 'IT', dialCode: '+39', name: 'Italy', flag: 'https://flagcdn.com/w40/it.png' },
    { code: 'ES', dialCode: '+34', name: 'Spain', flag: 'https://flagcdn.com/w40/es.png' },
    { code: 'NL', dialCode: '+31', name: 'Netherlands', flag: 'https://flagcdn.com/w40/nl.png' },
    { code: 'SE', dialCode: '+46', name: 'Sweden', flag: 'https://flagcdn.com/w40/se.png' },
    { code: 'NO', dialCode: '+47', name: 'Norway', flag: 'https://flagcdn.com/w40/no.png' },
    { code: 'CH', dialCode: '+41', name: 'Switzerland', flag: 'https://flagcdn.com/w40/ch.png' },
    { code: 'TR', dialCode: '+90', name: 'Turkey', flag: 'https://flagcdn.com/w40/tr.png' },
    { code: 'SA', dialCode: '+966', name: 'Saudi Arabia', flag: 'https://flagcdn.com/w40/sa.png' },
    { code: 'PK', dialCode: '+92', name: 'Pakistan', flag: 'https://flagcdn.com/w40/pk.png' },
    { code: 'BD', dialCode: '+880', name: 'Bangladesh', flag: 'https://flagcdn.com/w40/bd.png' },
    { code: 'EG', dialCode: '+20', name: 'Egypt', flag: 'https://flagcdn.com/w40/eg.png' },
    { code: 'NG', dialCode: '+234', name: 'Nigeria', flag: 'https://flagcdn.com/w40/ng.png' },
    { code: 'AR', dialCode: '+54', name: 'Argentina', flag: 'https://flagcdn.com/w40/ar.png' },
    { code: 'CL', dialCode: '+56', name: 'Chile', flag: 'https://flagcdn.com/w40/cl.png' },
    { code: 'CO', dialCode: '+57', name: 'Colombia', flag: 'https://flagcdn.com/w40/co.png' },
    { code: 'ID', dialCode: '+62', name: 'Indonesia', flag: 'https://flagcdn.com/w40/id.png' },
    { code: 'MY', dialCode: '+60', name: 'Malaysia', flag: 'https://flagcdn.com/w40/my.png' },
    { code: 'TH', dialCode: '+66', name: 'Thailand', flag: 'https://flagcdn.com/w40/th.png' },
    { code: 'VN', dialCode: '+84', name: 'Vietnam', flag: 'https://flagcdn.com/w40/vn.png' },
    { code: 'PH', dialCode: '+63', name: 'Philippines', flag: 'https://flagcdn.com/w40/ph.png' },
    { code: 'PL', dialCode: '+48', name: 'Poland', flag: 'https://flagcdn.com/w40/pl.png' },
    { code: 'UA', dialCode: '+380', name: 'Ukraine', flag: 'https://flagcdn.com/w40/ua.png' },
    { code: 'GR', dialCode: '+30', name: 'Greece', flag: 'https://flagcdn.com/w40/gr.png' },
    { code: 'PT', dialCode: '+351', name: 'Portugal', flag: 'https://flagcdn.com/w40/pt.png' },
    { code: 'IL', dialCode: '+972', name: 'Israel', flag: 'https://flagcdn.com/w40/il.png' },
    { code: 'IE', dialCode: '+353', name: 'Ireland', flag: 'https://flagcdn.com/w40/ie.png' },
    { code: 'FI', dialCode: '+358', name: 'Finland', flag: 'https://flagcdn.com/w40/fi.png' },
    { code: 'DK', dialCode: '+45', name: 'Denmark', flag: 'https://flagcdn.com/w40/dk.png' },
    { code: 'CZ', dialCode: '+420', name: 'Czech Republic', flag: 'https://flagcdn.com/w40/cz.png' },
    { code: 'HU', dialCode: '+36', name: 'Hungary', flag: 'https://flagcdn.com/w40/hu.png' },
    { code: 'RO', dialCode: '+40', name: 'Romania', flag: 'https://flagcdn.com/w40/ro.png' },
    { code: 'BE', dialCode: '+32', name: 'Belgium', flag: 'https://flagcdn.com/w40/be.png' },
    { code: 'AT', dialCode: '+43', name: 'Austria', flag: 'https://flagcdn.com/w40/at.png' },
];



import React, { useState, useRef, useEffect } from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    StyleSheet,
    TextInput,
    Modal,
    FlatList,
    Image,
    Dimensions
} from 'react-native';

// Get screen height for dynamic modal height
const { height: screenHeight } = Dimensions.get("window");

const InternationalPhoneInput = ({
    value = '',
    onChange = () => { },
    defaultCountry = 'US',
    placeholder = 'Enter phone number',
    style = {},
    inputStyle = {},
    buttonStyle = {},
    textStyle = {},
    countryCode,
    setCountryCode,
    phoneRef
}) => {
    console.log({ countryCode })
    const [selectedCountry, setSelectedCountry] = useState(
        countryData.find(country => country.code === defaultCountry) || countryData[0]
    );


    // useEffect(() => {
    //     setSelectedCountry(countryData.find(country => country.code === defaultCountry))
    // }, [defaultCountry])
    useEffect(() => {
  const country = countryData.find(c => c.code === defaultCountry) || countryData[0];
  setSelectedCountry(country);
}, [defaultCountry]);


    const [phoneNumber, setPhoneNumber] = useState("");
    const [isCountryPickerVisible, setCountryPickerVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const inputRef = useRef(null);


    const filteredCountries = countryData.filter(country =>
        country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        country.dialCode.includes(searchQuery) ||
        country.code.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        if (setCountryCode) {
            setCountryCode(country.code);
        }
        setCountryPickerVisible(false);
        setSearchQuery('');
        if (inputRef.current) {
            inputRef.current.focus();
        }
        onChange("");
        setPhoneNumber("");
    };

    const handlePhoneNumberChange = (text) => {
        setPhoneNumber(text);
        onChange(text);
    };

    const renderCountryItem = ({ item }) => (
        <TouchableOpacity
            style={styles.countryItem}
            onPress={() => handleCountrySelect(item)}
        >
            <Image source={{ uri: item.flag }} style={styles.flagImage} />
            <View style={styles.countryInfo}>
                <Text style={styles.countryName}>{item.name}</Text>
                <Text style={styles.countryCode}>{item.code}</Text>
            </View>
            <Text style={styles.dialCode}>{item.dialCode}</Text>
        </TouchableOpacity>
    );

    return (
        <View style={[styles.container, style]}>
            <View style={[styles.inputContainer, inputStyle]}>
                <TouchableOpacity
                    style={[styles.countrySelector, buttonStyle]}
                    onPress={() => setCountryPickerVisible(true)}
                >
                    <Image source={{ uri: selectedCountry.flag }} style={[styles.selectedFlag, buttonStyle]} />
                    <Text style={[styles.countryDialCode, textStyle]}>{selectedCountry.dialCode}</Text>
                    <Text style={[styles.dropdownIcon, textStyle]}>▼</Text>
                </TouchableOpacity>

                <TextInput
                    ref={phoneRef || inputRef}
                    style={[styles.phoneInput,
                        textStyle,
                    {
                        outlineStyle: "none",   // 👈 focus outline hat gaya
                        borderWidth: 0,         // 👈 koi unwanted border nahi
                        boxShadow: "none",      // 👈 chrome default shadow bhi hat gaya
                    },
                    ]}
                    placeholder={placeholder}
                    value={value || phoneNumber}
                    onChangeText={handlePhoneNumberChange}
                    keyboardType="phone-pad"
                    placeholderTextColor="#999"
                />
            </View>

            {/* Modal */}
            <Modal
                visible={isCountryPickerVisible}
                animationType="slide"
                transparent={true}
                onRequestClose={() => {
                    setCountryPickerVisible(false);
                    setSearchQuery('');
                }}
            >
                <View style={styles.modalContainer}>
                    <View style={[styles.modalContent, { height: screenHeight * 0.9 }]}>

                        {/* Header with Title + Close Icon */}
                        <View style={styles.modalHeader}>
                            <Text style={styles.modalTitle}>Select Country</Text>
                            <TouchableOpacity onPress={() => setCountryPickerVisible(false)}>
                                <Text style={styles.closeIcon}>✕</Text>
                            </TouchableOpacity>
                        </View>

                        {/* Search Input */}
                        <View style={styles.searchContainer}>
                            <TextInput
                                style={styles.searchInput}
                                placeholder="Search countries..."
                                value={searchQuery}
                                onChangeText={setSearchQuery}
                                placeholderTextColor="#999"
                                autoFocus={true}
                            />
                        </View>

                        {/* Country List */}
                        <FlatList
                            data={filteredCountries}
                            renderItem={renderCountryItem}
                            keyExtractor={(item) => item.code}
                            style={styles.countryList}
                            keyboardShouldPersistTaps="handled"
                            initialNumToRender={20}
                            windowSize={10}
                        />
                    </View>
                </View>
            </Modal>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    inputContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#ddd',
        height: 50,
        paddingHorizontal: 12,
    },
    countrySelector: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 12,
        paddingRight: 12,
        borderRightWidth: 1,
        borderRightColor: '#eee',
    },
    selectedFlag: {
        width: 24,
        height: 18,
        marginRight: 8,
        borderRadius: 2,
    },
    countryDialCode: {
        fontSize: 16,
        color: '#333',
        fontWeight: '500',
        marginRight: 4,
    },
    dropdownIcon: {
        fontSize: 10,
        color: '#666',
    },
    phoneInput: {
        flex: 1,
        fontSize: 16,
        color: '#333',
        height: '100%',
        padding: 0,
    },
    modalContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    modalContent: {
        width: '100%',
        backgroundColor: 'white',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        padding: 16,
    },
    modalHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    modalTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#2c3e50',
    },
    closeIcon: {
        fontSize: 22,
        color: '#333',
        fontWeight: 'bold',
    },
    searchContainer: {
        marginBottom: 16,
    },
    searchInput: {
        backgroundColor: '#f5f5f5',
        padding: 12,
        borderRadius: 8,
        fontSize: 16,
        color: '#333',
    },
    countryList: {
        marginBottom: 16,
    },
    countryItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 12,
        paddingHorizontal: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#f0f0f0',
    },
    flagImage: {
        width: 30,
        height: 22,
        marginRight: 12,
        borderRadius: 3,
    },
    countryInfo: {
        flex: 1,
    },
    countryName: {
        fontSize: 16,
        color: '#333',
        marginBottom: 2,
    },
    countryCode: {
        fontSize: 12,
        color: '#666',
    },
    dialCode: {
        fontSize: 16,
        color: '#666',
        fontWeight: '500',
    },
});

export default InternationalPhoneInput